import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Upload, X } from "lucide-react";
import { useRef } from "react";

export default function ImagePicker({ label, value, onChange, testId, aspect = "aspect-video" }) {
  const fileRef = useRef(null);

  const onFile = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    const reader = new FileReader();
    reader.onload = () => onChange(reader.result);
    reader.readAsDataURL(f);
    e.target.value = ""; // allow re-selecting same file
  };

  return (
    <div>
      <Label>{label}</Label>
      <div className="mt-2 flex flex-col gap-2">
        <div className="flex flex-wrap gap-2">
          <Input
            className="flex-1 min-w-[240px]"
            placeholder="Paste image URL or upload below"
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
            data-testid={testId ? `${testId}-url` : undefined}
          />
          <button
            type="button"
            onClick={() => fileRef.current?.click()}
            data-testid={testId ? `${testId}-upload-btn` : undefined}
            className="inline-flex items-center gap-2 bg-sage-500 hover:bg-sage-600 text-white rounded-md px-4 py-2 text-sm transition-colors"
          >
            <Upload className="w-4 h-4" strokeWidth={1.5} /> Upload
          </button>
          {value && (
            <button
              type="button"
              onClick={() => onChange("")}
              data-testid={testId ? `${testId}-clear-btn` : undefined}
              className="inline-flex items-center gap-2 bg-white border border-earth-200 hover:bg-earth-50 text-earth-700 rounded-md px-3 py-2 text-sm transition-colors"
              title="Clear image"
            >
              <X className="w-4 h-4" strokeWidth={1.5} />
            </button>
          )}
          <input
            ref={fileRef}
            type="file"
            accept="image/*"
            onChange={onFile}
            className="hidden"
            data-testid={testId ? `${testId}-file-input` : undefined}
          />
        </div>
        {value && (
          <div className={`${aspect} rounded-xl overflow-hidden bg-earth-100 border border-earth-200`}>
            <img src={value} alt="preview" className="w-full h-full object-cover" />
          </div>
        )}
      </div>
    </div>
  );
}
